import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Button from 'components/Button/Button';
import TitleWrapper from 'components/TitleWrapper/TitleWrapper';
import { BUTTON_VARIANT } from 'constants/interfaces';

import TopicIdentificationAssistant from './components/TopicIdentificationAssistant/TopicIdentificationAssistant';

import type IMaterialityAssessmentTopicRefinement from './interfaces/IMaterialityAssessmentTopicRefinement';

import styles from './scss/MaterialityAssessmentTopicRefinement.module.scss';

function MaterialityAssessmentTopicRefinementView({
  goBack, onHandleNext, onChangeStatus, topics, onConfigure,
  onPrevious, mainVcTabs, handleClickVcTab, activeVcTab, isViewOnly = false,
}: IMaterialityAssessmentTopicRefinement) {
  const { t } = useTranslation();
  return (
    <div className={styles.root}>
      <div className={styles.tabs}>
        {mainVcTabs.map((item) => (
          <Button
            key={[item.id, item.name].join('-')}
            title={item.name}
            variant={BUTTON_VARIANT.ghost}
            onClick={() => handleClickVcTab(item.id)}
            className={clsx(styles.tab, { [styles.active]: activeVcTab === item.id })}
          />
        ))}
      </div>
      <span className={styles.header}>{t('materialityAssessment.topicIdentificationAssistant')}</span>
      <div className={styles.rootContainer}>
        <div className={styles.wrapper}>
          <TitleWrapper
            description={t('materialityAssessment.titleStakeholderDescription')}
          />
          <div className={styles.contentWrapper}>
            { topics.map((topic) => (
              <TopicIdentificationAssistant
                key={topic.id}
                topic={topic}
                onChangeStatus={onChangeStatus}
                onConfigure={onConfigure}
                isViewOnly={isViewOnly}
              />
            )) }
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={goBack}
          />
          <div className={styles.rightButtons}>
            <Button
              title={t('common.prev')}
              onClick={onPrevious}
              className={styles.prevButton}
            />
            <Button
              title={t('common.next')}
              onClick={onHandleNext}
              className={styles.button}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MaterialityAssessmentTopicRefinementView;
